import { checkout_Info, DynamicYieldEventName, FormActualName } from './../enum/analytics.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class DynamicYieldService {
  DynamicYieldMissingFlag = false;
  public track(eventName: string, data?: any) {
    try {
      if (!(window as any).DY || typeof (window as any).DY.API !== 'function') {
        console.log('Dynamic Yield is not present');
        this.DynamicYieldMissingFlag = true;
        return;
      } else {
        switch (eventName) {
          case DynamicYieldEventName.AddToCart:
            this.reportAddToCartDY(eventName, data);
            break;
          case DynamicYieldEventName.FormLoadPersonalDetails:
            this.reportFormLoadDY(eventName, data);
            break;
          case DynamicYieldEventName.FormStartPersonalDetails:
            this.reportFormInteractionDY(eventName, data);
            break;
          case DynamicYieldEventName.FormStartVDPPrequal:
            this.reportFormInteractionDY(eventName, data);
            break;
          case DynamicYieldEventName.FormSuccessPersonalDetails:
            this.reportFormSuccessDY(eventName, data);
            break;
          case DynamicYieldEventName.FormSuccessVDPPrequal:
            this.reportFormSuccessDY(eventName, data);
            break;
          case DynamicYieldEventName.Purchase:
            this.reportPurchaseDY(eventName, data);
            break;
          case DynamicYieldEventName.FormLoadCreditApplication:
            this.reportFormLoadCreditApp(eventName, data);
            break;
          case DynamicYieldEventName.FormSuccessCreditApplication:
            this.reportFormSuccessCreditApp(eventName, data);
            break;
          case DynamicYieldEventName.PrequalModalAddToCart:
            this.reportPrequalModalAddToCart(data);
            break;
          case DynamicYieldEventName.PrequalModalFormLoad:
            this.reportPreuqlModalFormLoad();
            break;
          case DynamicYieldEventName.PrequalModalFormStart:
            this.reportPreuqlModalFormStart();
            break;
          case DynamicYieldEventName.PrequalModalFormSubmit:
            this.reportPreuqlModalFormSubmit();
            break;
          case DynamicYieldEventName.PrequalModalFormSuccess:
            this.reportPreuqlModalFormSuccess(data);
            break;
          case DynamicYieldEventName.PrequalModalFormFailure:
            this.reportPreuqlModalFormFailure();
            break;
          case DynamicYieldEventName.PrequalModalPurchase:
            this.reportPrequalModalPurchase(data);
            break;
        }
      }
    } catch (e) {
      /* istanbul ignore next */
      console.error('There was an error on DY events', e);
    }

  }

  reportAddToCartDY(eventName: string, data: any) {
    const dy = (window as any).DY;
    const price = data && data.enh_vehic_price ? Number(data.enh_vehic_price.replace(/\D/g, '')) : 0;
    dy?.API('event', {
      name: eventName,
      properties: {
        dyType: 'add-to-cart-v1',
        value: price,
        currency: 'USD', // Must be USD always
        productId: data && data.enh_vehic_id ? data.enh_vehic_id.toString() : '',
        quantity: 1
      }
    });
  }

  reportFormLoadDY(eventName: string, data: any) {
    const dy = (window as any).DY;
    const price = data && data.enh_vehic_price ? Number(data.enh_vehic_price.replace(/\D/g, '')) : 0;

    if (eventName = FormActualName.vdpPrequalification) {
      dy?.API('event', {
        name: DynamicYieldEventName.FormLoadVDPPreQual,
        properties: {
          form_name: data.form_name,
          form_actual_name: eventName,
          enh_action: checkout_Info.enh_action_add,
          enh_vehic_brand: data.enh_vehic_brand,
          enh_vehic_id: data.enh_vehic_id,
          enh_vehic_name: data.enh_vehic_name,
          enh_vehic_price: price,
          enh_vehic_variant: data.enh_vehic_variant,
          enh_vehic_category: data.enh_vehic_category,
          enh_vehic_discount: data.enh_vehic_discount,
          enh_vehic_list: data.enh_vehic_list,
          enh_vehic_quantity: data.enh_vehic_quantity,
          enh_checkout_option: data.enh_checkout_option,
          enh_checkout_step: data.enh_checkout_step
        }
      });
    } else {
      dy?.API('event', {
        name: eventName,
        properties: {
          form_name: data.form_name,
          form_actual_name: data.form_actual_name,
          enh_action: data.enh_action,
          enh_vehic_brand: data.enh_vehic_brand,
          enh_vehic_id: data.enh_vehic_id,
          enh_vehic_name: data.enh_vehic_name,
          enh_vehic_price: price,
          enh_vehic_variant: data.enh_vehic_variant,
          enh_vehic_category: data.enh_vehic_category,
          enh_vehic_discount: data.enh_vehic_discount,
          enh_vehic_list: data.enh_vehic_list,
          enh_vehic_quantity: data.enh_vehic_quantity,
          enh_checkout_option: data.enh_checkout_option,
          enh_checkout_step: data.enh_checkout_step
        }
      });
    }

  }

  reportFormSuccessDY(eventName: string, data: any) {
    const dy = (window as any).DY;

    dy?.API('event', {
      name: eventName,
      properties: {
        form_actual_name: data.form_actual_name,
        form_name: data.form_name,
        enh_action: data.enh_action,
        lead_date: data.lead_date,
        lead_hyperion: data.lead_hyperion,
        lead_provider_id: data.lead_provider_id,
        lead_store_name: data.lead_store_name,
        lead_cust_zip: data.lead_cust_zip,
        enh_booking_value: data.enh_vehic_price,
        enh_checkout_option: data.enh_checkout_option,
        enh_vehic_brand: data.enh_vehic_brand,
        enh_vehic_category: data.enh_vehic_category,
        enh_vehic_discount: data.enh_vehic_discount,
        enh_vehic_id: data.enh_vehic_id,
        enh_vehic_list: data.enh_vehic_list,
        enh_vehic_name: data.enh_vehic_name,
        enh_vehic_price: data.enh_vehic_price,
        enh_vehic_quantity: data.enh_vehic_quantity,
        enh_vehic_variant: data.enh_vehic_variant
      }
    });
  }


  reportPurchaseDY(eventName: string, data: any) {
    const dy = (window as any).DY;
    const price = data && data.enh_vehic_price ? Number(data.enh_vehic_price.replace(/\D/g, '')) : 0;
    dy?.API('event', {
      name: eventName,
      properties: {
        dyType: 'purchase-v1',
        value: price,
        quantity: 1,
        currency: 'USD',
        cart: [{ productId: data.enh_vehic_id, quantity: 1, itemPrice: price }]
      }
    });
  }

  reportFormLoadCreditApp(eventName: string, data: any) {
    const dy = (window as any).DY;
    dy?.API('event', {
      name: eventName,
      properties: {
        form_actual_name: data.form_actual_name,
        form_name: data.form_name,
        event: 6
      }
    });
  }
  reportFormSuccessCreditApp(eventName: string, data: any) {
    const dy = (window as any).DY;
    dy?.API('event', {
      name: eventName,
      properties: {
        form_actual_name: data.form_actual_name,
        form_name: data.form_name,
        lead_provider_id: data.lead_provider_id,
        lead_cust_zip: data.lead_cust_zip
      }
    });
  }

  reportFormInteractionDY(eventName: string, data: any) {
    const dy = (window as any).DY;
    dy?.API('event', {
      name: eventName,
      properties: {
        enh_action: data.enh_action,
        enh_checkout_option: data.enh_checkout_option,
        enh_checkout_step: data.enh_checkout_step,
        enh_vehic_brand: data.enh_vehic_brand,
        enh_vehic_category: data.enh_vehic_category,
        enh_vehic_discount: data.enh_vehic_discount,
        enh_vehic_id: data.enh_vehic_id,
        enh_vehic_list: data.enh_vehic_list,
        enh_vehic_name: data.enh_vehic_name,
        enh_vehic_price: data.enh_vehic_price,
        enh_vehic_quantity: data.enh_vehic_quantity,
        enh_vehic_variant: data.enh_vehic_variant
      }
    });
  }

  pageGroup() {
    const pageGroup = (window.location.href.indexOf('cars-for-sale') !== -1 ? 'SRP' : 
    (window.location.href.indexOf('cars') !== -1 ? 'VDP' : 'Home'));
    return pageGroup;
  }

  reportPrequalModalAddToCart(VIN) {
    const dy = (window as any).DY;
    dy?.API('event', {
      name: 'Add To Cart',
      properties: {
        dyType: "add-to-cart-v1",
        value: 248,
        quantity: 1,
        currency: "USD",
        productId: VIN ? VIN : "Pre-Qual No VOI",
        cart: [{
          productId: VIN ? VIN : "Pre-Qual No VOI",
          quantity: 1,
          itemPrice: 248,
        }
        ]
      }
    });
  }

  reportPreuqlModalFormLoad() {
    const dy = (window as any).DY;
    dy?.API('event', {
      name: this.pageGroup() + ' Prequal Form Load',
      properties: {
        form_actual_name: "prequal-form"
      }
    });
  }

  reportPreuqlModalFormStart() {
    const dy = (window as any).DY;
    dy?.API('event', {
      name: this.pageGroup() + ' Prequal Form Start',
      properties: {
        form_actual_name: "prequal-form"
      }
    });
  }

  reportPreuqlModalFormSubmit() {
    const dy = (window as any).DY;
    dy?.API('event', {
      name: this.pageGroup() + ' Prequal Submit',
      properties: {
        form_actual_name: "prequal-form"
      }
    });
  }

  reportPreuqlModalFormSuccess(data) {
    const dy = (window as any).DY;
    dy?.API('event', {
      name: this.pageGroup() + ' Prequal Submit Success',
      properties: {
        form_actual_name: "prequal-form",
        prequalOutcome: data
      }
    });
  }

  reportPreuqlModalFormFailure() {
    const dy = (window as any).DY;
    dy?.API('event', {
      name: this.pageGroup() + ' Prequal Submit Failure',
      properties: {
        form_actual_name: "prequal-form"
      }
    });
  }

  reportPrequalModalPurchase(data) {
    const dy = (window as any).DY;
    dy?.API('event', {
      name: 'Purchase',
      properties: {
        dyType: "purchase-v1",
        uniqueTransactionId: data?.LeadId ? data.LeadId : "",
        value: 248,
        quantity: 1,
        currency: "USD",
        cart: [{
          productId: data?.Vin ? data.Vin : "Pre-Qual No VOI",
          quantity: 1,
          itemPrice: 248,
        }
        ]
      }
    });
  }
}
